<template>
    <button class="btn btn-primary" :class="btnClass" :disabled="poster.submitted" @click="posterPost()">
        <slot></slot>
    </button>
</template>

<script>
import poster from '../../../../shared/mixins/poster'

export default {

    mixins: [
        poster
    ],

    props: {
        manager: {
            required: true
        },
        btnClass: {
            default: ''
        }
    },

    computed: {
        posterUrl () {
            return '/managers/' + this.manager.id + '/sendForgotPassword'
        }
    },

    methods: {
        posterSuccess (data) {
            bus.$emit(
                'notify',
                'Återställningslänk för lösenord har skickats'
            )
            this.$emit('success')
        }
    }
}
</script>
